import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { FindDuplicateCountries } from 'src/app/product-capture/utils/find-duplicate-countries-in-array';

export function countriesOfOfferJurisdictionsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const countriesOfOfferFormArr = control as UntypedFormArray;

    const countries = countriesOfOfferFormArr.controls.map((formGroup) => {
      const country = formGroup.get('jurisdictionsLegal');
      return country.value;
    });

    const indexArr = FindDuplicateCountries(countries);

    indexArr.map((i) => {
      const groupAtIndex: UntypedFormGroup = countriesOfOfferFormArr.at(
        i
      ) as UntypedFormGroup;
      const country: AbstractControl = groupAtIndex.get('jurisdictionsLegal');

      country.setErrors({
        incorrect: true,
        message:
          'Duplicate jurisdiction. Countries of Offer can only be selected once',
      });
    });

    return null;
  };
}
